import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';
import { REDUCER_KEY } from './reportConfigurationsTypes';

export const getReportConfigurationStore = (state: Pick<RootState, REDUCER_KEY>) => state[REDUCER_KEY];

export const getIsLoading = createSelector(getReportConfigurationStore, (store) => store.isLoading);
export const getLoadPending = createSelector(getReportConfigurationStore, (store) => store.loadPending);
export const getError = createSelector(getReportConfigurationStore, (store) => store.error);
export const getResourcesById = createSelector(getReportConfigurationStore, (store) => store.resourcesById);

export const getLastSyncDate = createSelector(getReportConfigurationStore, (store) => store.lastSyncDate);
export const getReportConfigurationById = getResourcesById;

export const getReportsConfigurationsByName = createSelector(getReportConfigurationById, (reportConfigurationsById) =>
  reportConfigurationsById.reduce(
    (result, reportConfiguration) => result.set(reportConfiguration.name, reportConfiguration),
    ImmutableMap(),
  ),
);

export const getReportConfigByUniqueIdentifier = createSelector(
  [
    getReportConfigurationById,
    (_state: unknown, props: { name: string }) => props.name,
    (_state: unknown, props: { persistentType: string }) => props.persistentType,
  ],
  (configsById, name, persistentType) => {
    return configsById?.find(
      (config) =>
        config?.get('name') === name && config?.get('persistentType') === persistentType && config.id !== undefined,
    );
  },
);

export const getReportConfigByUniqueIdentifierWeb = createSelector(
  [
    getReportConfigurationById,
    (_state: unknown, props: { getTabName: () => string }) => props.getTabName(),
    (_state: unknown, props: { persistentType: string }) => props.persistentType,
  ],
  (configsById, name, persistentType) => {
    return configsById?.find(
      (config) =>
        config?.get('name') === name && config?.get('persistentType') === persistentType && config.id !== undefined,
    );
  },
);
